( function( $ ) {
    // Progress bar script =================================================================================================
    if( $( '.progress-bar' ).length ) {
        var sticky = new Waypoint.Sticky({
            element: $( '.progress-bar' ),
            offset: $( '.progress-bar' ).outerHeight(),
            wrapper: '<div class="progress-sticky-wrapper" />'
        });

        var footerProgressWaypoint = new Waypoint({
            element: $( 'footer' ),
            handler: function(direction) {
                $( '.progress-bar' ).toggleClass( 'stuck' );
            }, 
            offset: function() {
                return $( '.progress-bar' ).height()
            }
        });

        if( $( '.theme-container' ).length ) {
            $( window ).on('scroll resize', getProgress('.theme-container'));
        }

        function getProgress( container ) {
            if( !$( container ).length ) {
                return;
            }
            
            var scrollTop = $( window ).scrollTop() + $( window ).height();
            var pixelsPastNav = scrollTop - $( container ).offset().top;
            var progress = pixelsPastNav / $( container ).height();
            progress = Math.floor( Math.min( Math.max( progress, 0 ), 1 ) * 100 );
            
            $( '.progress-bar-inner' ).width( progress + '%' );

            if ( progress >= 100 ) {
                $( '.progress-bar' ).addClass('finished');
            } else if ( progress < 100 && $( '.progress-bar' ).hasClass('finished') ) {
                $( '.progress-bar' ).removeClass('finished');
            }
        }
    }
} )( jQuery );
